// extracted by mini-css-extract-plugin
export default {"header":"header_Cf5wa","scrolled":"scrolled_Fygse","listWrapper":"listWrapper_EKmum","list":"list_Bjkqq","container":"container_AT06k","logo":"logo_I4JFr","arrow":"arrow_UKTHV"};